export const postThumbnailReverseProxy = (url: string) => {
  return `https://publer-media-downloader.kalemi-code4806.workers.dev?url=${encodeURIComponent(url)}&noDownload=true`;
};
